import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
  matchRoutes,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
} from 'react-router';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.globalHandlersIntegration({
      onerror: true,
      onunhandledrejection: true,
    }),
  ],
  tracesSampleRate: 1.0,
  attachStacktrace: true,
  beforeSend(event, hint) {
    event.tags = {
      ...event.tags,
      url: window.location.href,
    };

    if (event.exception) {
      if (
        hint.originalException instanceof PromiseRejectionEvent ||
        (typeof hint.originalException === 'object' &&
          hint.originalException !== null &&
          'reason' in hint.originalException)
      ) {
        event.tags.errorType = 'unhandledRejection';
      } else {
        event.tags.errorType = 'unhandled';
      }
    }

    return event;
  },
});
